export const dateFormat = "DD MMM yy";
export const dateFormatExtended = "ddd, DD MMM yy";
export const monthFormat = "MMM yy";
export const dateTimeFormat = "DD MMM yy hh:mm a";
export const timeFormat = "hh:mm a";
